import { isStyleRequired } from '@/features/ai/lib/imageFailureText'
import { isStartBlocked, type StartFailure } from '@/features/ai/lib/parseStartError'
import type { ActiveJob } from '@/features/ai/studioStartTypes'

export interface DrawGates {
  /**
   * «Стиль урегулирован» — либо у курса уже есть `image_style`, либо заказан
   * набор пилотов (сам выбор варианта из набора и есть выбор стиля, поэтому
   * при заказанном наборе бэк не требует `image_style`). Считает ДИАЛОГ ОДНОЙ
   * формулой (`hasStyle || effectivePilotSets > 0`) и отдаёт готовый булев —
   * вторая независимая копия этого условия уже расходилась с первой внутри
   * этой же ветки (Important 3, финальное ревью: баннер говорил одно, кнопка
   * рядом — другое).
   */
  styleSettled: boolean
  /** Смета приехала: без неё неизвестны ни план, ни цена, ни потолок. */
  hasQuote: boolean
  busyJob: ActiveJob | null
  isStarting: boolean
  failure: StartFailure | null
  hasUnsavedBlockDraft: boolean
  /** Курс на проверке (`useIsCourseFrozen`): отрисовка пишет в контент
   *  заявки, бэк её отбил бы. */
  isFrozen: boolean
  /** Единственное, что различает режимы: у авто — «есть что рисовать» из
   *  сметы, у ручного — «выбрано хоть одно место» (пустой план приезжает из
   *  пикера и при превышении потолка прогона). */
  hasPlan: boolean
}

/**
 * Гейты запуска отрисовки — ОДИН набор на оба режима диалога. Вынесены из
 * компонента ради лимита сложности, а не ради переиспользования: вторая копия
 * любого из этих условий — это ровно тот баг, когда кнопка живая там, где
 * старт гарантированно отобьётся.
 *
 * Отказы `422 image_style_required` и `503 not_configured` держат кнопку
 * погашенной, даже если смета выглядит живой: оба — свойства ОКРУЖЕНИЯ и
 * данных, а не неудача клика, и следующий клик упрётся в тот же отказ.
 */
export const canStartDraw = (g: DrawGates): boolean =>
  g.styleSettled &&
  g.hasQuote &&
  g.hasPlan &&
  g.busyJob === null &&
  !g.isStarting &&
  !isStyleRequired(g.failure) &&
  !isStartBlocked(g.failure) &&
  !g.hasUnsavedBlockDraft &&
  !g.isFrozen
